import React from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { CircleMoreIcon as Pending, CircleTickIcon as Completed, CircleCloseIcon as Failed, } from '../atoms';
import { Colours } from '../tokens';
const useStyles = createUseStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px',
        marginLeft: '4px',
    },
    Completed: {
        color: Colours.success,
        backgroundColor: Colours.successLight,
    },
    Failed: {
        color: Colours.danger,
        backgroundColor: Colours.dangerLight,
    },
    Pending: {
        color: Colours.warning,
        backgroundColor: Colours.warningLight,
    },
    Inactive: { backgroundColor: Colours.alabaster },
    icon: { width: '14px', height: '14px', marginRight: '4px' },
}));
const icons = {
    Pending,
    Completed,
    Failed,
    Inactive: () => React.createElement("span", null),
};
const Badge = ({ children, status }) => {
    const classes = useStyles();
    const Icon = icons[status];
    return (React.createElement("span", { className: classnames(classes.root, classes[status]) },
        React.createElement(Icon, { className: classnames(classes.icon, classes[status]) }),
        children));
};
export default Badge;
//# sourceMappingURL=Badge.js.map